import { styled } from "styled-components";

export const PersonalColorSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;
`;
